import React, { useContext } from 'react';
import styles from '../../css/components/common/partner.css';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import { getAssetUrl } from '../../helpers/get-asset-url';

function PartnerLogo() {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const backgroundPosterImage = onelpsParams.partner.image?.src && getAssetUrl() + require('../../img/' + GAMEID + '/partners/' + onelpsParams.partner.image.src);
	const imageStyles = {
		backgroundImage: 'url(' + backgroundPosterImage + ')',
		width: onelpsParams.partner.image.width,
		height: onelpsParams.partner.image.height
	};
	
	return (
		<div
			className={`${styles.partnerLogo} ${styles[onelpsParams.partner.name]}`}
			style={{
				top: onelpsParams.partner.image.position?.top,
			}}
		>
			{onelpsParams.partner.url ? (
				<a
					href={onelpsParams.partner.url} 
					target='_blank'
					className={styles.partnerImage} 
					rel="noreferrer"
					data-testid="partner-logo-link"
					style={imageStyles}
				>
				</a>
			) : (
				<div
					className={styles.partnerImage}
					data-testid="partner-logo"
					style={imageStyles}
				>
				</div>
			)}
		</div>
	);
}

export default PartnerLogo;